import CardInfo from '../../components/CardInfo';
import img1 from '../../assets/quartocerra/cama.jpg';
import img2 from '../../assets/quartocerra/umacama.jpg';
import img3 from '../../assets/quartocerra/vidrobanheiro.jpg';
import img4 from '../../assets/quartoDuasCamas/cama_sacada.jpg';
import img5 from '../../assets/quartoDuasCamas/cama_sacada2.jpg';
import img6 from '../../assets/quartoDuasCamas/cama_sacada3.jpg';
import Maps from '../../components/Maps';
import ImageTitle from '../../components/ImageTitle';
import EventImage from '../../components/EventImage';

function Dashboard() {
  const cardsInfo = [
    {
      title: "Quarto com vista para natureza",
      description: "Desfrute de uma vista deslumbrante do cerrado e da represa, proporcionando um ambiente tranquilo e relaxante. Com Smart TV e Wi-Fi gratuito.",
      images: [img1, img2, img3],
      order: { carousel: 2, text: 1 },
      icons: ["bi bi-segmented-nav", "bi bi-tv", "bi bi-wifi"],
      textIcons: ["Cama de Casal", "Smart TV", "Wifi Gratuito"]
    },
    {
      title: "Quarto de casal com vista",
      description: "Perfeito para família, este quarto oferece duas camas, garantindo conforto e praticidade. O ambiente aconchegante é ideal para momentos de descanso.",
      images: [img4, img5, img6],
      order: { carousel: 1, text: 1 },
      icons: ["bi bi-people-fill", "bi bi-tv", "bi bi-wifi"],
      textIcons: ["2 Camas", "Smart TV", "Wifi Gratuito"]
    },
    {
      title: "Quarto adaptado",
      description: "Projetado com acessibilidade total, proporcionando conforto e praticidade. Equipado com cama de casal, Smart TV e Wi-Fi gratuito.",
      images: [img1, img2, img3],
      order: { carousel: 2, text: 1 },
      icons: ["bi bi-universal-access", "bi bi-tv", "bi bi-wifi"],
      textIcons: ["Acessibilidade", "Smart TV", "Wifi Gratuito"]
    }
  ];

  return (
    <div className="container-fluid px-0">
      <ImageTitle 
        titulo="Pousada e Restaurante Villa Capetinga" 
        paragrafo="Uma pousada charmosa em Santo Hilário, Minas Gerais, ideal para pessoas que buscam tranquilidade na natureza" 
      />

      <div className="container mt-5 pt-4">
        <EventImage />
      </div>
      
      <div className="container my-5 py-4">
        <div className="title-section">
          <div className="title-tag"></div>
          <h2 className="title-text">Conheça nossos quartos</h2>
        </div>
        
        {cardsInfo.map((card, index) => (
          <CardInfo key={index} id={`ads${index}`} {...card} />
        ))}

        <div className="title-section mt-5 pt-5">
          <div className="title-tag"></div>
          <h2 className="title-text">Localização</h2>
        </div>
        <Maps />
      </div>
    </div>
  );
}

export default Dashboard;